export default "__VITE_ASSET__BEARZsyf__"